module.exports = __webpack_public_path__ + "img/move4.f1ea9e54.png";